const routes = [
    {
        path: "/coop/business-point-events",
        component: () => import("../pages/Index.vue"),
        meta: {
            isAuthenticated: true
        }
    },
    {
        path: "/coop/business-point-events/:id/participants",
        component: () => import("../pages/Participants.vue"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
